




import React from 'react';
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { Link } from "react-router-dom";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

const Popup = ({ open, setOpen, product }) => {
  // Calculate the appropriate price based on quantity tiers
  // const { getCurrencySymbol, convertPrice } = useCurrency();
  const calculatePrice = (quantity, price_1_249, price_250_999, price_1000plus) => {
    if (quantity >= 25) {
      return price_1000plus;
    } else if (quantity >= 12) {
      return price_250_999;
    } else {
      return price_1_249;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      className="relative z-10"
    >
      <DialogBackdrop className="fixed inset-0 bg-gray-500/75 transition-opacity" />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start">
                <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-100 sm:mx-0 sm:size-10">
                  <ExclamationTriangleIcon
                    className="size-6 text-green-600"
                    aria-hidden="true"
                  />
                </div>
                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <DialogTitle
                    as="h3"
                    className="text-base font-semibold text-gray-900"
                  >
                    Product Added to Cart
                  </DialogTitle>
                  <div className="mt-2">
                    {product ? (
                      <div className="space-y-2">
                        <p>
                          <strong>Product id:</strong> {product.id}
                        </p>
                        <p>
                          <strong>Product name:</strong> {product.name}
                        </p>
                        
                        <div className="mt-4 flex gap-2">
                          <Link
                            to="/basket"
                            className="inline-block bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
                            onClick={() => setOpen(false)}
                          >
                            View Cart
                          </Link>
                        </div>
                      </div>
                    ) : (
                      <p>No product data available.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default Popup;
